// extracted by mini-css-extract-plugin
export default {"teams":"Team_teams__bcnb-","content":"Team_content__e1YDy"};